import { hasLocizeTranslation } from 'lib/utils/locize'

const messages = {
  title: ['Complete the Look', 'แต่งลุคให้ครบ'],
  choose: ['Choose your size', 'เลือกไซซ์'],
  add: ['Add to Bag', 'เพิ่มลงถุง'],
  close: ['Close', 'ปิด'],
  adding: ['Adding…', 'กำลังเพิ่มสินค้า…'],
  added: ['Added to your bag', 'เพิ่มสินค้าลงถุงแล้ว'],
  error: [
    "Couldn't add this item. Please try again.",
    'เพิ่มสินค้าลงถุงไม่สำเร็จ กรุณาลองอีกครั้ง',
  ],
  uncertain: [
    'Could not confirm the addition. Open your bag to check.',
    'ยังยืนยันการเพิ่มสินค้าไม่ได้ กรุณาเปิดถุงช้อปปิ้งเพื่อตรวจสอบ',
  ],
  checkBag: ['Check bag', 'ตรวจสอบถุง'],
  unavailable: [
    'This size is no longer available. Choose another size.',
    'ไซซ์นี้หมดแล้ว โปรดเลือกไซซ์อื่น',
  ],
  soldOut: ['Sold out', 'สินค้าหมด'],
  select: ['Select a size', 'เลือกไซซ์'],
  delivery: ['Delivery cost and timing', 'ค่าจัดส่งและระยะเวลาจัดส่ง'],
  shippingPolicy: ['View shipping policy', 'ดูนโยบายการจัดส่ง'],
  returns: ['Returns', 'การคืนสินค้า'],
  eligible: [
    'Returnable — policy conditions apply',
    'คืนสินค้าได้ตามเงื่อนไขนโยบาย',
  ],
  notReturnable: ['This item cannot be returned', 'สินค้านี้ไม่สามารถคืนได้'],
  returnsPolicy: ['View return conditions', 'ดูเงื่อนไขการคืนสินค้า'],
}

export default (t, language, key) =>
  hasLocizeTranslation(
    t,
    `PDP_BUYING_${key.toUpperCase()}`,
    messages[key][language === 'th' ? 1 : 0],
  )
